var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakereLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01292 8.80015C8.01292 10.9815 6.36311 12.6267 4.12543 12.6267C1.88775 12.6267 0.200012 10.9815 0.200012 8.80015C0.200012 6.61885 1.84983 4.97363 4.12543 4.97363C6.40103 4.97363 8.01292 6.61885 8.01292 8.80015ZM8.01292 23.999C8.01292 26.1803 6.36311 27.8255 4.12543 27.8255C1.88775 27.8255 0.200012 26.1803 0.200012 23.999C0.200012 21.8177 1.84983 20.1725 4.12543 20.1725C6.40103 20.1725 8.01292 21.8177 8.01292 23.999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5168 31.9998L27.312 22.1618H21.6192V31.9998H14.47V0.799805H27.3499C35.4776 0.799805 40.2299 5.01082 40.2299 11.4808C40.2299 15.7694 38.1477 19.0599 34.3778 20.7827L41.8 31.9998H33.513H33.5168ZM21.6192 15.9987H27.0389C30.8089 15.9987 33.0883 14.4274 33.0883 11.4808C33.0883 8.53418 30.8089 6.9629 27.0389 6.9629H21.6192V15.9987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakereLogo);
export default __webpack_public_path__ + "static/media/makere-logo.705440ef896877f5645e533880258f0d.svg";
export { ForwardRef as ReactComponent };